module.exports = __webpack_public_path__ + "_redirects";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader?name=_redirects!./src/redirects
 ** module id = 613
 ** module chunks = 0
 **/